import type { FunctionComponent } from 'react';

type SoftSkillIconProperties = {
    readonly variant: 'feedback' | 'job-architecture' | 'job-profile';
};
export const SoftSkillIcon: FunctionComponent<SoftSkillIconProperties> = ({ variant }) => {
    return (
        <svg fill="none" height="16" style={{ flexShrink: 0 }} viewBox="0 0 16 16" width="16">
            <circle
                cx="8"
                cy="8"
                fill={variant === 'job-profile' || variant === 'feedback' ? '#040F16' : '#FF6C00'}
                r="7"
            />
        </svg>
    );
};
